/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { OrderOrigin } from './OrderOrigin';
import {
    OrderOriginFromJSON,
    OrderOriginFromJSONTyped,
    OrderOriginToJSON,
    OrderOriginToJSONTyped,
} from './OrderOrigin';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { ShipmentProjection } from './ShipmentProjection';
import {
    ShipmentProjectionFromJSON,
    ShipmentProjectionFromJSONTyped,
    ShipmentProjectionToJSON,
    ShipmentProjectionToJSONTyped,
} from './ShipmentProjection';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { InvoicePrices } from './InvoicePrices';
import {
    InvoicePricesFromJSON,
    InvoicePricesFromJSONTyped,
    InvoicePricesToJSON,
    InvoicePricesToJSONTyped,
} from './InvoicePrices';

/**
 * 
 * @export
 * @interface InvoiceSummary
 */
export interface InvoiceSummary {
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    id: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof InvoiceSummary
     */
    number: HeoTransactionNumber;
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof InvoiceSummary
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {Address}
     * @memberof InvoiceSummary
     */
    billingAddress: Address;
    /**
     * 
     * @type {Address}
     * @memberof InvoiceSummary
     */
    shippingAddress: Address;
    /**
     * 
     * @type {PaymentType}
     * @memberof InvoiceSummary
     */
    paymentType?: PaymentType;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof InvoiceSummary
     */
    paymentMethod: PaymentMethod;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSummary
     */
    paymentDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSummary
     */
    paymentDueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof InvoiceSummary
     */
    total: number;
    /**
     * 
     * @type {InvoicePrices}
     * @memberof InvoiceSummary
     */
    prices: InvoicePrices;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceSummary
     */
    filed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceSummary
     */
    canceled: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    canceledReason?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    reference: string;
    /**
     * 
     * @type {Array<OrderOrigin>}
     * @memberof InvoiceSummary
     */
    orderOrigins?: Array<OrderOrigin>;
    /**
     * 
     * @type {Array<OrderType>}
     * @memberof InvoiceSummary
     */
    orderTypes?: Array<OrderType>;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSummary
     */
    createdAt: Date;
    /**
     * 
     * @type {Array<ShipmentProjection>}
     * @memberof InvoiceSummary
     */
    shipments: Array<ShipmentProjection>;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceSummary
     */
    hasDocument: boolean;
}



/**
 * Check if a given object implements the InvoiceSummary interface.
 */
export function instanceOfInvoiceSummary(value: object): value is InvoiceSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('billingAddress' in value) || value['billingAddress'] === undefined) return false;
    if (!('shippingAddress' in value) || value['shippingAddress'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('prices' in value) || value['prices'] === undefined) return false;
    if (!('filed' in value) || value['filed'] === undefined) return false;
    if (!('canceled' in value) || value['canceled'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('shipments' in value) || value['shipments'] === undefined) return false;
    if (!('hasDocument' in value) || value['hasDocument'] === undefined) return false;
    return true;
}

export function InvoiceSummaryFromJSON(json: any): InvoiceSummary {
    return InvoiceSummaryFromJSONTyped(json, false);
}

export function InvoiceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': HeoTransactionNumberFromJSON(json['number']),
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'billingAddress': AddressFromJSON(json['billingAddress']),
        'shippingAddress': AddressFromJSON(json['shippingAddress']),
        'paymentType': json['paymentType'] == null ? undefined : PaymentTypeFromJSON(json['paymentType']),
        'paymentMethod': PaymentMethodFromJSON(json['paymentMethod']),
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'paymentDueDate': json['paymentDueDate'] == null ? undefined : (new Date(json['paymentDueDate'])),
        'total': json['total'],
        'prices': InvoicePricesFromJSON(json['prices']),
        'filed': json['filed'],
        'canceled': json['canceled'],
        'canceledReason': json['canceledReason'] == null ? undefined : json['canceledReason'],
        'reference': json['reference'],
        'orderOrigins': json['orderOrigins'] == null ? undefined : ((json['orderOrigins'] as Array<any>).map(OrderOriginFromJSON)),
        'orderTypes': json['orderTypes'] == null ? undefined : ((json['orderTypes'] as Array<any>).map(OrderTypeFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'shipments': ((json['shipments'] as Array<any>).map(ShipmentProjectionFromJSON)),
        'hasDocument': json['hasDocument'],
    };
}

export function InvoiceSummaryToJSON(json: any): InvoiceSummary {
    return InvoiceSummaryToJSONTyped(json, false);
}

export function InvoiceSummaryToJSONTyped(value?: InvoiceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': HeoTransactionNumberToJSON(value['number']),
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'billingAddress': AddressToJSON(value['billingAddress']),
        'shippingAddress': AddressToJSON(value['shippingAddress']),
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'paymentDate': value['paymentDate'] == null ? value['paymentDate'] : value['paymentDate'].toISOString().substring(0,10),
        'paymentDueDate': value['paymentDueDate'] == null ? value['paymentDueDate'] : value['paymentDueDate'].toISOString().substring(0,10),
        'total': value['total'],
        'prices': InvoicePricesToJSON(value['prices']),
        'filed': value['filed'],
        'canceled': value['canceled'],
        'canceledReason': value['canceledReason'],
        'reference': value['reference'],
        'orderOrigins': value['orderOrigins'] == null ? undefined : ((value['orderOrigins'] as Array<any>).map(OrderOriginToJSON)),
        'orderTypes': value['orderTypes'] == null ? undefined : ((value['orderTypes'] as Array<any>).map(OrderTypeToJSON)),
        'createdAt': value['createdAt'].toISOString(),
        'shipments': ((value['shipments'] as Array<any>).map(ShipmentProjectionToJSON)),
        'hasDocument': value['hasDocument'],
    };
}

